import ConfirmationDialog from 'components/Common/ConfirmationDialog';
import React, { useCallback, useContext, useEffect } from 'react';
import { FlowVersionHistoryContext } from './FlowRun/FlowVersionHistoryProvider';
import {
  useDeleteFlowVersion,
} from 'api/flows';
import { useParams } from 'react-router-dom';


const DeleteFlowVersionDialog = () => {
  const { crId } = useParams();
  const {
    deleteFlowVersionDialog,
    handleDeleteFlowVersionDialogClose,
  } = useContext(FlowVersionHistoryContext);
  const deleteFlowVersion = useDeleteFlowVersion(crId, deleteFlowVersionDialog?.crFlow?.flowID);

  const handleOnConfirm = useCallback(() => {
    deleteFlowVersion.mutate({
      version: deleteFlowVersionDialog?.version,
      crId,
    });
    handleDeleteFlowVersionDialogClose();
  }, [deleteFlowVersion, deleteFlowVersionDialog, crId, handleDeleteFlowVersionDialogClose]);

  useEffect(() => {
    if (deleteFlowVersion.isSuccess) {
      deleteFlowVersion.reset();
    }
  }, [deleteFlowVersion]);

  return (
    <ConfirmationDialog
      open={deleteFlowVersionDialog.open}
      title='Delete Flow Version?'
      message={
        `We found ${deleteFlowVersionDialog?.runCount ?? 0} flow run${deleteFlowVersionDialog?.runCount !== 1 ? 's' : ''} associated with version ${deleteFlowVersionDialog?.version ?? ''}.

          Deleting this version will:
          • Delete all ${deleteFlowVersionDialog?.runCount ?? 0} flow run${deleteFlowVersionDialog?.runCount !== 1 ? 's' : ''}
          • Remove associated run reports

          This action cannot be undone.`
      }
      loading={deleteFlowVersion.isLoading}
      onCancel={() => handleDeleteFlowVersionDialogClose()}
      confirmActionLabel='Delete Version'
      onConfirm={() => handleOnConfirm()}
    />
  );
};


export default DeleteFlowVersionDialog;
